
import IconCross from '../../icons/icon-cross/index.vue';
import IconComplete from '../../icons/icon-complete/index.vue';
import IconWarningTriangle from '../../icons/icon-warning-triangle/index.vue';
import IconInfoFilled from '../../icons/icon-info-filled/index.vue';

export default {
  name: 'rzNotification',
  components: {
    IconCross,
    IconComplete,
    IconWarningTriangle,
    IconInfoFilled,
  },
  props: {
    theme: {
      type: String,
      default: 'info',
    },
    text: {
      type: String,
      required: true,
    },
    withoutClose: {
      type: Boolean,
      default: false,
    },
    hide: {
      type: Boolean,
      default: false,
    },
    initial: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      icons: {
        info: 'icon-info-filled',
        success: 'icon-complete',
        warning: 'icon-warning-triangle',
        error: 'icon-warning-triangle', 
      }
    };
  },
  computed: {
    themeIcon() {
      return this.icons[this.theme];
    }
  },
  mounted() {
    this.$emit('rendered', this.$el);
  },
  methods: {
    close() {
      this.$emit('close', this.$el);
    },
  },
};
